import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { usePrefersDarkModeMediaQuery } from "./useTheme.js";
import { getTheme } from "./theme.js";
import { ViewportBreakpointsProvider } from "./responsive/ViewportBreakpointsProvider.js";
import { ElementBreakpointsProvider } from "./responsive/ElementBreakpointsProvider.js";
function isValidTheme(theme) {
    return 'dark' === theme || 'light' === theme;
}
const CHRONO_THEME_PREFERENCE_KEY = 'CHRONOSPHERE_THEME';
const CHRONO_THEME_DEFAULT = 'light';
const ThemeProvider_ThemeProvider = ({ children, applicationRoot, mode, baselineCss = true, isNestedTheme })=>{
    let defaultMode = CHRONO_THEME_DEFAULT;
    const userSpecifiedDarkMode = usePrefersDarkModeMediaQuery();
    defaultMode = userSpecifiedDarkMode ? 'dark' : defaultMode;
    const val = window.localStorage.getItem(CHRONO_THEME_PREFERENCE_KEY);
    defaultMode = isValidTheme(val) ? val : defaultMode;
    const themeMode = mode ?? defaultMode;
    window.localStorage.setItem(CHRONO_THEME_PREFERENCE_KEY, themeMode);
    const theme = useMemo(()=>getTheme(themeMode, applicationRoot), [
        themeMode,
        applicationRoot
    ]);
    return /*#__PURE__*/ jsxs(ThemeProvider, {
        theme: theme,
        children: [
            baselineCss && /*#__PURE__*/ jsx(CssBaseline, {}),
            isNestedTheme ? children : /*#__PURE__*/ jsx(ViewportBreakpointsProvider, {
                children: /*#__PURE__*/ jsx(ElementBreakpointsProvider, {
                    children: children
                })
            })
        ]
    });
};
export { ThemeProvider_ThemeProvider as ThemeProvider };

//# sourceMappingURL=ThemeProvider.js.map